import(/* webpackMode: "eager" */ "/app/app/rooms/[roomName]/error.tsx");
